import Vue from 'vue';
import Notification from './Notification.vue';

Notification.newInstance = (props: Object) => {
  const _props = props || {};
  const Instance = new Vue({
    render(h) {
      return h(Notification, {
        props: _props
      });
    }
  });
  const component = Instance.$mount();
  document.body.appendChild(component.$el);

  return {
    destory() {
      document.body.removeChild(component.$el);
    }
  };
};

class Message {
  name: 'Message';
  timer: number;
  private show(option: { time: number; content: string; callback?: Function; type: string }) {
    if (this.timer) return;
    const notifica = Notification.newInstance({
      ...option
    });
    this.timer = window.setTimeout(() => {
      notifica.destory();
      if (option.callback) option.callback();
      this.timer = 0;
    }, option.time || 1000);
  }
  success(option: { time: number; content: string; callback?: Function }) {
    this.show({
      ...option,
      type: 'success'
    });
  }
  warn(option: { time: number; content: string; callback?: Function }) {
    this.show({
      ...option,
      type: 'warn'
    });
  }
  error(option: { time: number; content: string; callback?: Function }) {
    this.show({
      ...option,
      type: 'error'
    });
  }
  info(option: { time: number; content: string; callback?: Function }) {
    this.show({
      ...option,
      type: 'info'
    });
  }
}

export default new Message();
